import React, { Component, Fragment } from 'react';
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'
import { Container, Row, Col, CardGroup, Card, CardBody, Button } from 'reactstrap';

import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import { LoginField } from '../../../views/controls/_FieldValication'
import Messages from '../../../notifications/Messages'
import Errors from '../../../notifications/Errors'
import { validateLogin } from '../../../lib/validation'
import EnvConfig from '../../../config/env'

// Import actions
import {loginRequest, clearMessages} from './actions';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      IsMsgFbShowing: true
    };

    this.registerClick = this.registerClick.bind(this);
    this.forgotPassClick = this.forgotPassClick.bind(this);

    //clear timer if there
    if (props.header && typeof props.header.clearIntervalIds == 'function') {
      props.header.clearIntervalIds();
    }
  }

  submit = (values) => {
    this.props.loginRequest(values, this.props.history)
  }

  registerClick = (e) => {
    e.preventDefault();
    this.props.history.push('/register');
  }

  forgotPassClick = (e) => {
    e.preventDefault();
    this.props.history.push('/login-issue?callback=login');
  }
  clearMessages = (e) => {
    this.props.clearMessages()
  }
  componentDidMount(){
    document.title = EnvConfig.PAGE_TITLE
  }
  render() {
    const {
      handleSubmit, // remember, Redux Form injects this into our props
      login: {
        requesting,
        messages,
        errors,
      },
    } = this.props
    // const isMobile = isMobileAndTablet();
    return (
      <Fragment>
      <div className="app flex-row align-items-center bg-master " key="1">
        <Container>
          <Row>
            <Col md="12">
              <div className="logo">
                <a href={EnvConfig.HTML_REF}>
                  <img alt="Logo" src="../img/logo.png" />
                </a>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center frm-login">
            <Col lg="6" md="7" sm="12">
              <CardGroup>
                <Card className="col-sm-12 col-login">
                  <BlockUi tag="div" blocking={requesting}>
                    <CardBody>
                      <form className="widget-form" method="post" onSubmit={handleSubmit(this.submit)}>
                        <h1>Đăng nhập</h1>
                        <p className="text-muted">Đăng nhập tài khoản của bạn</p>
                        <Field icon="icon-user" type="text" 
                          onChange={e => this.clearMessages(e)}
                          name="email" 
                          placeholder="Tài khoản hoặc email"
                          component={LoginField} 
                          className="form-control" />
                        <Field icon="icon-lock"
                          type="password"
                          name="password"
                          onChange={e => this.clearMessages(e)}
                          placeholder="Mật khẩu"
                          component={LoginField}
                          className="form-control" />
                        <Row>
                          <Col md="12">
                            {!requesting && !!errors.length && (
                              <Errors message="Failure to signup due to:" errors={errors} />
                            )}
                            {!requesting && !!messages.length && (
                              <Messages messages={messages} />
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" sm="6">
                            <Button disabled={!this.props.valid} color="success" className="px-4" action="submit">Đăng nhập</Button>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </BlockUi>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
      </Fragment>
    );
  }
}

// Grab only the piece of state we need
const mapStateToProps = state => ({
  login: state.login,
  header: state.header,
})

// make Redux state piece of `login` and our action `loginRequest`
// available in this.props within our component
const connected = connect(mapStateToProps, { loginRequest, clearMessages })(Login)

// in our Redux's state, this form will be available in 'form.login'
const formed = reduxForm({
  form: 'login',
  validate: validateLogin,
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js